import {requiredHeaders} from "@/helpers/authservice/requiredHeaders";
import {log} from "../../state/pinia/log";
import router from "@/router";

export const simplepharmUserService = {
    login,
    logout,
    register,
    refreshToken,
    requestPasswordReset,
    confirmPasswordReset,
};

function login(email, password) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };

    return fetch(`/jwt/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.removeItem('userLoggedOut');
            }

            log.log("User auth:")
            log.log(user)
            log.log(user.token)


            return user;
        });
}

function refreshToken() {

    const requestOptions = {
        method: 'POST',
        headers: requiredHeaders(),
        body: JSON.stringify({})
    };

    return fetch(`/jwt/refreshToken`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // refreshToken successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.removeItem('userLoggedOut');
            }
            return user;
        });
}

async function logout() {
    // remove user from local storage to log user out
    try {
        await fetch(`/jwt/logout`, {
            method: 'POST',
            headers: requiredHeaders(),
        });

    } catch (e) {
        console.warn("Logout request failed (best-effort)", e);
    }
    localStorage.removeItem('user');
    localStorage.setItem('userLoggedOut', "true");
    await router.push("/login");
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`/jwt/register`, requestOptions).then(handleResponse);
}

function requestPasswordReset(email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
    };
    return fetch(`/auth/password-reset/request`, requestOptions).then(handleResponse);
}

function confirmPasswordReset(token, newPassword) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
    };
    return fetch(`/auth/password-reset/confirm`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    console.log("handleResponse::", response)
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                log.log("Unauthorized - logging out")
                logout();
                location.reload(true);
            }else if(response.status === 403){
                log.log("Forbidden - logging out")
                logout();
                // location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

export function getTokenExpiration(token) {
    if (!token) return null;

    try {
        const base64Url = token.split('.')[1];

        // Zamiana znaków URL-safe na standardowe Base64
        // Używamy regex /-/g aby zamienić WSZYSTKIE wystąpienia, a nie tylko pierwsze
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

        // Dekodowanie Base64 w przeglądarce z obsługą UTF-8
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const payload = JSON.parse(jsonPayload);

        return payload.exp * 1000; // Konwersja na milisekundy
    } catch (e) {
        console.error("Błąd dekodowania tokenu", e);
        return null;
    }
}

export function isTokenCloseToExpiry(token, bufferTime = 1000) { // 60 * 1000 - 1 minute // todo: show info and count down to logout to user
    const expirationTime = getTokenExpiration(token);
    if (!expirationTime) return false;

    const currentTime = Date.now();

    // Return true if the token will expire within the next 'bufferTime' (default 5 minutes)
    return currentTime >= expirationTime - bufferTime;
}
